<template>
  <div style="left: 0">
    <!-- ////////////////////////////////////////
    /////////// D E S K T O P   /////////////////
    ///////////////////////////////////////-->

    <aside class="sidebar navbar-perfil menu is-hidden-touch">
      <div class="head-sidebar">
        <br><br><br><br>
        <!--////////// I M A G E N - P E R F I L  ///////////-->
          <div class="navbar-brand">
            <!--<div v-if="verifPhotographyCompute != null">
              <img :src="obtenerUrl(photography)" fluid alt="Responsive image"/>
            </div>-->
            <div>
              <img src="../../statics/img/avatar.png" fluid alt="Responsive image"/>
            </div>
          </div>
        </div>
        <br>

        <div style="overflow-y: scroll;">
          <ul :key="model.id" v-for="model in vertical"
              class="menu-list cd-accordion-menu">
            <sidebar-item :model="model"></sidebar-item>
          </ul>
        </div>
    </aside>

    <!-- ////////////////////////////////////////
    /////////// M O B I L E   /////////////////
    ///////////////////////////////////////-->

    <aside class="sidebar navbar-perfil menu is-fixed-top is-hidden-desktop">
      <div class="head-sidebar menu-label">
        <br><br><br><br>
        <!--////////// I M A G E N - P E R F I L  ///////////-->
        <div class="navbar-brand">
          <!--<div v-if="verifPhotographyCompute != null">
            <img :src="obtenerUrl(photography)" fluid alt="Responsive image"/>
          </div>-->
          <div>
            <img src="../../statics/img/avatar.png" fluid alt="Responsive image"/>
          </div>
        </div>
      </div>
      <br>

      <div style="overflow-y: scroll;">
        <ul :key="model.id" v-for="model in vertical"
            class="menu-list cd-accordion-menu">
          <sidebar-item :model="model"></sidebar-item>
        </ul>
      </div>
    </aside>
  </div>
</template>
<script>
  const endpointBase = __API__
  import SidebarItem from './SidebarItem'
    export default {
      components:{SidebarItem},
      data() {
        return {
          vertical: null,
          open: false,
          photography:null,
          endpointBase,
          urlImagenLogo : '../../../statics/img/user2.png',
        }
      },
      mounted() {
        this.$http.get('api/menuAdmin')
          .then((response) => {
            console.log(response.data[0]);

            this.vertical = response.data;
          });
      },
      methods:{
        obtenerUrl(idimg){
          if(idimg){
            if(idimg != "" || idimg != "null"){
              return this.endpointBase+'images/imgsPersonal/'+idimg
            }else{
              return this.urlImagenLogo
            }
          }else {
            return this.urlImagenLogo
          }

        },
        toggle: function(){
          this.open = !this.open;
        }
      },
      computed: {
        datosMenu() {
          return {
            vertical: []
          }
        },
        verifPhotographyCompute () {

          this.$http.get('api/photographyByPersonal')
            .then((response) => {
              console.log(response.data);
              this.photography = response.data;
            });
          return this.photography
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/TheSlidebarAdmin.vue